import { Operation } from 'types';

import { convertToCurrency } from '../../utils';

/**
 * Valor de cada boleto. Boleto é um instrumento brasileiro, então a operação
 * é sempre BR — mas o formato vem do `convertToCurrency` (Intl.NumberFormat)
 * em vez de um `toFixed(2)` manual, que produzia "R$ 3285.00": separador
 * decimal e de milhar errados para pt-BR.
 */
export const formatBankslipAmount = (amount?: number) =>
  convertToCurrency(Operation.BR, amount ?? 0);
